// TODO: HACK: Use proper imports once the main workspace (`ulule`) uses date-fns v2
import en from '../../../../node_modules/date-fns/esm/locale/en-US/index.js'
import fr from '../../../../node_modules/date-fns/esm/locale/fr/index.js'
import es from '../../../../node_modules/date-fns/esm/locale/es/index.js'
import ca from '../../../../node_modules/date-fns/esm/locale/en-CA/index.js'
import it from '../../../../node_modules/date-fns/esm/locale/it/index.js'
import de from '../../../../node_modules/date-fns/esm/locale/de/index.js'
import nl from '../../../../node_modules/date-fns/esm/locale/nl/index.js'

export const locales = {
  en,
  fr,
  es,
  ca,
  it,
  de,
  nl,
}

export const defaultLocaleName = 'en'
